export * from './teses-juridicas-chat'
export * from './thesis-cluster'
